import { createSlice } from "@reduxjs/toolkit";
import type { AuthState } from "./types";
import { reducers } from "./reducers";

const initialState: AuthState = {
  refreshToken: null,
  token: null,
  runtimeToken: null,
  appIsAuthenticated: false,
  authStatus: null,
  enterPinErrorCount: 0,
  enterPinHasError: false,
  shouldEnterPin: false,
  loginError: null,
};

export const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: reducers,
});

export const {
  logout,
  setRefreshToken,
  setToken,
  setAppIsAuthenticated,
  setAuthStatus,
  incrementEnterPinErrorCount,
  setEnterPinError,
  clearEnterPinErrorCount,
  setShouldEnterPin,
  setRuntimeToken,
  setLoginError,
} = authSlice.actions;
